import { render, staticRenderFns } from "./FormGrupo.vue?vue&type=template&id=d18fc1ea&scoped=true"
import script from "./FormGrupo.vue?vue&type=script&lang=js"
export * from "./FormGrupo.vue?vue&type=script&lang=js"
import style0 from "./FormGrupo.vue?vue&type=style&index=0&id=d18fc1ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d18fc1ea",
  null
  
)

export default component.exports